(function () {
  var translations = {
    de: { hints: ['Nicht hilfreich', 'Wenig hilfreich', 'Ganz okay', 'Hilfreich', 'Sehr hilfreich'], status: 'Feedback-Status', noFeedback: 'Noch kein Feedback vorhanden', beFirst: 'Sei der Erste mit deiner Einschätzung zu diesem Beitrag.', noComment: 'Noch kein öffentlicher Kommentar', publicEmpty: 'Noch kein Community-Feedback vorhanden.', publicPrompt: 'Teile als Erster deine Einschätzung: Hat dir der Beitrag geholfen oder fehlt aus deiner Sicht noch etwas?', submitted: 'Feedback absenden', update: 'Feedback aktualisieren', yourFeedback: 'Dein Feedback', updateYourFeedback: 'Dein Feedback aktualisieren', member: 'Mitglied', approved: 'freigegebene', comment: 'Kommentar', comments: 'Kommentare', more: 'Weitere Kommentare anzeigen', stars: 'Sterne', rating: 'Bewertung', ratings: 'Bewertungen', pending: 'Danke für dein Feedback. Kommentare werden vor der Veröffentlichung kurz geprüft.', approvedMessage: 'Dein Kommentar ist freigegeben und öffentlich sichtbar.', rejected: 'Dein vorheriger Kommentar wurde nicht veröffentlicht. Du kannst dein Feedback aktualisieren.', loadError: 'Feedback konnte nicht geladen werden.', saveError: 'Feedback konnte nicht gespeichert werden.', locale: 'de-DE' },
    en: { hints: ['Not helpful', 'Slightly helpful', 'Okay', 'Helpful', 'Very helpful'], status: 'Feedback status', noFeedback: 'No feedback yet', beFirst: 'Be the first to share your view on this article.', noComment: 'No public comment yet', publicEmpty: 'No community feedback yet.', publicPrompt: 'Be the first to share your view. Did this article help or is something missing?', submitted: 'Submit feedback', update: 'Update feedback', yourFeedback: 'Your feedback', updateYourFeedback: 'Update your feedback', member: 'Member', approved: 'approved', comment: 'comment', comments: 'comments', more: 'Show more comments', stars: 'stars', rating: 'rating', ratings: 'ratings', pending: 'Thanks for your feedback. Comments are briefly reviewed before publication.', approvedMessage: 'Your comment is approved and publicly visible.', rejected: 'Your previous comment was not published. You can update your feedback.', loadError: 'Feedback could not be loaded.', saveError: 'Feedback could not be saved.', locale: 'en-GB' },
    es: { hints: ['No ayuda', 'Ayuda poco', 'Está bien', 'Ayuda', 'Ayuda mucho'], status: 'Estado del feedback', noFeedback: 'Todavía no hay feedback', beFirst: 'Sé la primera persona en compartir su opinión sobre este artículo.', noComment: 'Todavía no hay comentarios públicos', publicEmpty: 'Todavía no hay feedback de la comunidad.', publicPrompt: 'Sé la primera persona en compartir su opinión. ¿Te ha ayudado el artículo o falta algo?', submitted: 'Enviar feedback', update: 'Actualizar feedback', yourFeedback: 'Tu feedback', updateYourFeedback: 'Actualizar tu feedback', member: 'Miembro', approved: 'aprobado', comment: 'comentario', comments: 'comentarios', more: 'Mostrar más comentarios', stars: 'estrellas', rating: 'valoración', ratings: 'valoraciones', pending: 'Gracias por tu feedback. Revisamos brevemente los comentarios antes de publicarlos.', approvedMessage: 'Tu comentario está aprobado y es público.', rejected: 'Tu comentario anterior no se publicó. Puedes actualizar tu feedback.', loadError: 'No se ha podido cargar el feedback.', saveError: 'No se ha podido guardar el feedback.', locale: 'es-ES' }
  };

  function copy(root) { return translations[String(root.dataset.locale || 'de').slice(0, 2)] || translations.de; }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function starText(value) {
    var rating = Math.max(0, Math.min(5, Math.round(Number(value || 0))));
    return '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(0, 5 - rating);
  }

  function formatDate(root, value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString(copy(root).locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function endpoint(root, path) {
    return String(root.dataset.endpoint || '/apps/content-feedback').replace(/\/+$/, '') + path;
  }

  function contentType(root) {
    return root.dataset.contentType || 'page';
  }

  function contentReference(root) {
    return root.dataset.contentReference || '';
  }

  function targetQuery(root) {
    return 'content_type=' + encodeURIComponent(contentType(root)) + '&content_reference=' + encodeURIComponent(contentReference(root));
  }

  function setError(root, message) {
    var box = root.querySelector('[data-cs-feedback-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function renderPublicEmptyState(root) {
    renderSummaryCard(root, { count: 0, average_rating: 0 }, 0);
    renderComments(root, []);
  }

  function requestJson(url, options) {
    options = options || {};
    if (typeof window.fetch === 'function') {
      return window.fetch(url, {
        method: options.method || 'GET',
        headers: options.headers || { Accept: 'application/json' },
        body: options.body
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          var output = {};
          output.ok = response.ok;
          output.payload = payload;
          return output;
        });
      });
    }
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      var headers = options.headers || { Accept: 'application/json' };
      Object.keys(headers).forEach(function (key) {
        xhr.setRequestHeader(key, headers[key]);
      });
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        var payload = {};
        try {
          payload = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (parseError) {
          payload = {};
        }
        var output = {};
        output.ok = xhr.status >= 200 && xhr.status < 300;
        output.payload = payload;
        resolve(output);
      };
      xhr.onerror = function () { reject(new Error('Feedback konnte nicht geladen werden.')); };
      xhr.send(options.body || null);
    });
  }

  function updateStarState(root, stars, value, preview) {
    var language = copy(root);
    var rating = Number(value || 0);
    stars.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      var starValue = Number(input && input.value);
      label.classList.toggle(preview ? 'is-preview' : 'is-active', Boolean(rating && starValue <= rating));
      if (!preview) label.classList.remove('is-preview');
    });
    var hint = stars.closest('fieldset') && stars.closest('fieldset').querySelector('[data-cs-feedback-rating-hint]');
    if (hint) {
      hint.textContent = rating
        ? rating + ' / 5 ' + language.stars + ' - ' + language.hints[rating - 1]
        : (root.dataset.ratingHint || '');
    }
  }

  function selectedRating(stars) {
    var checked = stars.querySelector('input:checked');
    return checked ? checked.value : '';
  }

  function initStarControls(root) {
    var stars = root.querySelector('[data-cs-feedback-rating]');
    if (!stars || stars.dataset.ready) return;
    stars.dataset.ready = 'true';
    stars.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      label.addEventListener('mouseenter', function () { updateStarState(root, stars, input.value, true); });
      label.addEventListener('mouseleave', function () { updateStarState(root, stars, selectedRating(stars), false); });
      input.addEventListener('focus', function () { updateStarState(root, stars, input.value, true); });
      input.addEventListener('blur', function () { updateStarState(root, stars, selectedRating(stars), false); });
      input.addEventListener('change', function () { updateStarState(root, stars, input.value, false); });
    });
    updateStarState(root, stars, selectedRating(stars), false);
  }

  function renderSummaryCard(root, summary, commentCount) {
    var language = copy(root);
    var score = root.querySelector('[data-cs-feedback-score]');
    if (!score) return;
    var count = Number(summary.count || 0);
    var average = Number(summary.average_rating || 0);
    if (!count) {
      score.innerHTML = [
        '<span class="cs-content-feedback__score-label">' + language.status + '</span>',
        '<strong>' + language.noFeedback + '</strong>',
        '<span>' + language.beFirst + '</span>'
      ].join('');
      return;
    }
    score.innerHTML = [
      '<span class="cs-content-feedback__score-label">' + language.status + '</span>',
      '<strong>' + average.toLocaleString(language.locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' / 5</strong>',
      '<span class="cs-content-feedback__score-stars" aria-label="' + escapeHtml(average + ' / 5 ' + language.stars) + '">' + starText(average) + '</span>',
      '<div class="cs-content-feedback__score-meta">',
      '<span>' + count + ' ' + (count === 1 ? language.rating : language.ratings) + '</span>',
      '<span>' + commentCount + ' ' + language.approved + ' ' + (commentCount === 1 ? language.comment : language.comments) + '</span>',
      '</div>'
    ].join('');
  }

  function commentHtml(root, item) {
    var date = formatDate(root, item.updated_at);
    var language = copy(root);
    var author = item.display_name || language.member;
    return [
      '<article class="cs-content-feedback__comment">',
      '<div class="cs-content-feedback__comment-head">',
      '<div class="cs-content-feedback__author">',
      '<strong>' + escapeHtml(author) + '</strong>',
      '<span class="cs-content-feedback__badge">' + language.member + '</span>',
      '</div>',
      '<div class="cs-content-feedback__comment-meta">',
      '<span class="cs-content-feedback__comment-stars" aria-label="' + escapeHtml(item.rating + ' / 5 ' + language.stars) + '">' + starText(item.rating) + '</span>',
      date ? '<span>' + escapeHtml(date) + '</span>' : '',
      '</div>',
      '</div>',
      '<p>' + escapeHtml(item.comment) + '</p>',
      '</article>'
    ].join('');
  }

  function renderComments(root, rows) {
    var language = copy(root);
    var comments = root.querySelector('[data-cs-feedback-comments]');
    var countLabel = root.querySelector('[data-cs-feedback-comment-count]');
    if (countLabel) {
      countLabel.textContent = rows.length
        ? rows.length + ' ' + language.approved + ' ' + (rows.length === 1 ? language.comment : language.comments)
        : language.noComment;
    }
    if (!comments) return;
    if (!rows.length) {
      comments.innerHTML = [
        '<div class="cs-content-feedback__empty">',
        '<strong>' + language.publicEmpty + '</strong>',
        '<p>' + language.publicPrompt + '</p>',
        '</div>'
      ].join('');
      return;
    }
    var visibleCount = Number(root.dataset.visibleComments || 3);
    var visibleRows = rows.slice(0, visibleCount);
    comments.innerHTML = visibleRows.map(function (item) { return commentHtml(root, item); }).join('') + (
      rows.length > visibleCount
        ? '<button class="cs-content-feedback__more" type="button" data-cs-feedback-more>' + language.more + '</button>'
        : ''
    );
  }

  function renderViewerState(root, payload) {
    var language = copy(root);
    var form = root.querySelector('[data-cs-feedback-form]');
    var viewer = root.querySelector('[data-cs-feedback-viewer]');
    var submit = root.querySelector('[data-cs-feedback-submit]');
    var title = root.querySelector('[data-cs-feedback-form-title]');
    if (!form) return;
    if (!payload.viewer_feedback) {
      if (viewer) viewer.hidden = true;
      if (submit) submit.textContent = language.submitted;
      if (title) title.textContent = language.yourFeedback;
      return;
    }
    var input = form.querySelector('[name="rating"][value="' + payload.viewer_feedback.rating + '"]');
    if (input) input.checked = true;
    var textarea = form.querySelector('[name="comment"]');
    if (textarea) textarea.value = payload.viewer_feedback.comment || '';
    var stars = root.querySelector('[data-cs-feedback-rating]');
    if (stars) updateStarState(root, stars, payload.viewer_feedback.rating, false);
    if (submit) submit.textContent = language.update;
    if (title) title.textContent = language.updateYourFeedback;
    if (viewer) {
      var status = payload.viewer_feedback.moderation_status;
      var message = status === 'pending'
        ? language.pending
        : status === 'approved'
          ? language.approvedMessage
          : language.rejected;
      viewer.textContent = message;
      viewer.hidden = false;
    }
  }

  function renderSummary(root, payload) {
    var form = root.querySelector('[data-cs-feedback-form]');
    var login = root.querySelector('[data-cs-feedback-login]');
    var summary = payload.summary || {};
    var rows = Array.isArray(payload.comments) ? payload.comments : [];
    renderSummaryCard(root, summary, rows.length);
    renderComments(root, rows);
    if (form) form.hidden = !payload.customer_logged_in;
    if (login) login.hidden = Boolean(payload.customer_logged_in);
    renderViewerState(root, payload);
  }

  function shouldScrollToFeedback(root) {
    var params = new URLSearchParams(window.location.search || '');
    return window.location.hash === '#cs-content-feedback'
      || params.get('cs_feedback') === '1'
      || root.dataset.scrollAfterLogin === 'true';
  }

  function scrollToFeedback(root) {
    if (root.dataset.didFeedbackScroll === 'true' || !shouldScrollToFeedback(root)) return;
    root.dataset.didFeedbackScroll = 'true';
    window.setTimeout(function () {
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var form = root.querySelector('[data-cs-feedback-form]:not([hidden])');
      var target = form && (form.querySelector('input[name="rating"]') || form.querySelector('textarea') || form.querySelector('button'));
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }, 220);
  }

  function load(root) {
    return requestJson(endpoint(root, '/summary?' + targetQuery(root)), { headers: { Accept: 'application/json' } })
      .then(function (result) {
        var payload = result.payload || {};
        if (!result.ok || !payload.ok) throw new Error(payload.error || copy(root).loadError);
        root.__csFeedbackPayload = payload;
        renderSummary(root, payload);
        scrollToFeedback(root);
      });
  }

  function submit(root, form) {
    var formData = new FormData(form);
    var body = {
      content_type: root.dataset.contentType || 'page',
      content_reference: root.dataset.contentReference || '',
      rating: formData.get('rating'),
      comment: formData.get('comment') || ''
    };
    return requestJson(endpoint(root, '/feedback?' + targetQuery(root)), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (result) {
      var payload = result.payload || {};
      if (!result.ok || !payload.ok) throw new Error(payload.error || copy(root).saveError);
      var nextPayload = payload.public_summary || payload;
      root.__csFeedbackPayload = nextPayload;
      renderSummary(root, nextPayload);
      setError(root, '');
    });
  }

  document.querySelectorAll('[data-cs-content-feedback]').forEach(function (root) {
    root.dataset.ratingHint = root.querySelector('[data-cs-feedback-rating-hint]') ? root.querySelector('[data-cs-feedback-rating-hint]').textContent : '';
    initStarControls(root);
    load(root).catch(function () {
      renderPublicEmptyState(root);
      scrollToFeedback(root);
    });
    var form = root.querySelector('[data-cs-feedback-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        submit(root, form)
          .catch(function (error) { setError(root, error.message); })
          .finally(function () { if (button) button.disabled = false; });
      });
    }
    root.addEventListener('click', function (event) {
      var more = event.target.closest && event.target.closest('[data-cs-feedback-more]');
      if (!more || !root.__csFeedbackPayload) return;
      root.dataset.visibleComments = String(Number(root.dataset.visibleComments || 3) + 3);
      renderComments(root, Array.isArray(root.__csFeedbackPayload.comments) ? root.__csFeedbackPayload.comments : []);
    });
  });
})();
